import React, { Component } from 'react';
import {StyleSheet, Text, View, Animated, SafeAreaView, Pressable, FlatList, Easing, Dimensions, Image} from 'react-native';

import { Checkbox } from 'react-native-paper';
import { Overlay } from 'react-native-elements';

import GameData from './GameData';

import * as Font from 'expo-font';

const fps = 10;
const fpsDuration = 1000/fps;
const fpsPecent = 1/fps;
const MYEPSILON = 0.0001;

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

class ObjectiveScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      refresh: false,
      showOverlay: false,
      overlayTitle: "",
      overlayText: "",
    }
  
	GameData.objectiveScreen = this;
  
  }


  capitalize(str){
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
	/*
  componentDidMount() {
    this.interval = setInterval(function() {
            this.setState({refresh: !this.state.refresh});
          }.bind(this), fpsDuration);
    }
    
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  */
  
  renderObjectives({ item }) {
    if (item.objectives && GameData.meetRequirments(item.objectives) && !GameData.meetRequirments(item.requirements)) {
      return (
        <Pressable onPress={() =>  this.showObjective(item)} style={styles.item}>
            <View style={styles.row}>
				<Text style={styles.skillText}>{item.title}</Text>
			  </View>
        </Pressable>
      )
    }
    else {
      return (null);
    }
  }

  showObjective(item) {
    let schemeText = "Requirments: \n";
	
	let keys = [];
	if (item.requirements.map) {
		keys = Object.keys(item.requirements.map);
		for (let i = 0; i < keys.length; i++) {
			schemeText += this.capitalize(keys[i]) + ": " +  Math.floor(GameData.getPartialMap(keys[i], item.requirements.map[keys[i]])*100) + "%\n";
		}
	}
	
	if (item.requirements.skill) {
		keys = Object.keys(item.requirements.skill);
		for (let i = 0; i < keys.length; i++) {
			schemeText += GameData.skills[keys[i]].name + ": " + item.requirements.skill[keys[i]] + "\n";
		}
	}
	
	if (item.requirements.milestone) {
		schemeText += item.requirements.milestone + "\n";
	}

    this.setState({
      showOverlay: true,
      overlayTitle: item.title,
      overlayText: schemeText,
    });
  }

  closeOverlay() {
    this.setState({
      showOverlay: false,
    });    
  }

  render() {
    return (
      <View style={styles.container}>
        <Overlay visible={this.state.showOverlay} onBackdropPress={this.closeOverlay.bind(this)} overlayStyle={styles.overlayStyle}>
          <Text style={styles.overlayTitle}>{this.state.overlayTitle}</Text>
          <Text style={styles.overlayText}>{this.state.overlayText}</Text>
          <Pressable onPress={this.closeOverlay.bind(this)}>
            <Text style={styles.overlayPress}>Close</Text>
          </Pressable>
        </Overlay>
        <Text style={styles.title}>Ambitions</Text>
        <View>
          <FlatList
			initialNumToRender={GameData.messages.length}
            data={GameData.messages}
            renderItem={this.renderObjectives.bind(this)}
            //extraData={this.state.refresh}
			keyExtractor={item => item.title}
          />
        </View>
      </View >
    )
  }
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 20,
    flex: 1,
    backgroundColor: '#000000',
  },
  title: {
    color: '#ffffff',
    fontFamily: 'Alegreya-Regular',
    fontSize: 24,
    textAlign: 'center',
    borderBottomWidth: 2,
    borderColor: '#ffffff',
  },
  item: {
    margin: 2,
    borderWidth: 2,
    borderColor: '#ffffff',
  },
  overlayTitle: {
    fontFamily: 'Alegreya-Regular',
    color: '#ffffff',
    textAlign: 'center',
    textDecorationLine: 'underline',
    fontSize: 24,
  },
  overlayText: {
    fontFamily: 'Alegreya-Regular',
    color: '#ffffff',
    textAlign: 'left',
    fontSize: 16,
  },
  overlayPress: {
    borderWidth: 2,
    borderRadius: 6,
    padding: 2,
    marginTop: 20,
	fontSize: 20,
    fontFamily: 'Alegreya-Regular',
    color: '#ffffff',
    borderColor: '#ffffff',
    backgroundColor: '#000000',
    textAlign: 'center',
    alignSelf: 'center',
  },
  overlayStyle: {
    borderWidth: 2,
    padding: 20,
    maxWidth: '98%',
    fontFamily: 'Alegreya-Regular',
    borderColor: '#ffffff',
    backgroundColor: '#000000'
  },
  row: {
    flexDirection: "row",
    marginBottom: 0,
    height: 40,
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#ffffff',
  },
  skillText: {
    color: '#000000',
    fontFamily: 'Alegreya-Regular',
    fontSize: 20,
    flex: 1,
	textAlign: 'center',
  },
});

export default ObjectiveScreen;